import type { PriceUnit, ProductType, PublishStatus, ShippingMode } from '@/lib/api';

export const STATUS_LABEL: Record<PublishStatus, string> = {
  DRAFT: 'Draf',
  PUBLISHED: 'Tayang',
  ARCHIVED: 'Arsip',
};

export const TYPE_LABEL: Record<ProductType, string> = {
  CONFIGURABLE: 'Pilih opsi',
  GENERATOR: 'Generator',
  QUOTE: 'Konsultasi',
};

export const TYPE_HINT: Record<ProductType, string> = {
  CONFIGURABLE: 'Pembeli memilih opsi, harga langsung terhitung.',
  GENERATOR: 'Bentuk dan ukuran dari generator, harga ikut geometri.',
  QUOTE: 'Tanpa harga instan, pembeli mengirim permintaan penawaran.',
};

export const PRICE_UNIT_LABEL: Record<PriceUnit, string> = {
  PIECE: 'Per buah',
  SQUARE_METER: 'Per meter persegi',
  LINEAR_METER: 'Per meter lari',
};

export const SHIPPING_LABEL: Record<ShippingMode, string> = {
  COURIER: 'Kurir',
  PICKUP_ONLY: 'Ambil di tempat',
  QUOTE: 'Ongkir dinegosiasi',
};

export function formatRupiah(value: number): string {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(value);
}
